<template>
    <div class="activity_modal_box">
        <b-modal ref="modal" id="activity_modal" centered no-close-on-backdrop>
            <div class="text-center">
                <h4>活動辦法</h4>
                <p class="text-left">從12/5開始，Bella儂儂每天為你準備一個聖誕好禮，只要於官網倒數頁面下方留言，就有機會把每天的限時留言好禮帶回家，讓我們每天一起用驚喜，期待2018聖誕節！</p>
                <ol>
                    <li>請密切鎖定Bella儂儂粉絲專頁，每日將陸續公布當日倒數驚喜，並抽出昨日幸運得主</li>
                    <li>得獎者請於7日內私訊回覆聯絡資訊，逾期將放棄得獎資格</li>
                    <li>本活動依中華民國稅法規定進行稅款作業，詳細規定可上財政部網站查詢。</li>
                    <li>Bella儂儂保留此活動辦法之修改、變更之權利</li>
                </ol>
            </div>
            <div slot="modal-footer">
                <b-btn size="md" @click="hideModal">
                    關閉
                </b-btn>
            </div>
        </b-modal>
    </div>
</template>

<script>
    export default {
        name: "activity_modal",
        methods: {
            hideModal () {
                this.$refs.modal.hide()
            },
        }
    }
</script>

